import React, {FC} from "react";
// import EtherBalanceChart from "../../../../../resources/analytics/ether-balance-chart";
import CoinBalance from "../../../resources/analytics/coin-balance-chart";

const AnalyticsEtherBalance: FC = () => {
    return (
        <div>
            {/* <div className="d-flex justify-content-between align-items-center py-3">
                <h2 className="bs-card-header-title bs-analytics-font-weight-title">Time Series: <span className="bs-analytics-font-title">Ether Balance</span></h2>
                <div className="text-muted">
                    <span>Thu 21, Feb 2019 - Sun 12, Nov 2023</span>
                </div>
            </div> */}

            {/* <hr className='bs-ether-balance-hr' /> */}
            {/* <div className="row">
                <div className="col-md-6 col-lg-3 py-3 bs-ether-right-vertical-line">
                    <h5 className="h6 fw-bold mb-1 bs-card-header-title">
                        <i className="bi bi-circle-fill text-primary me-1" style={{ color: 'rgb(124, 181, 236)' }}></i><span>ETH Highest Balance</span>
                    </h5>
                    <div className="text-muted small mb-1">On Wed 27, Sept 2023</div>
                    <div className="fw-bold text-muted">275,000.0334790339 ETH</div>
                </div>
                <div className="col-md-6 col-lg-3 py-3 bs-ether-right-vertical-line">
                    <h5 className="h6 fw-bold mb-1 bs-card-header-title">
                        <i className="bi bi-circle-fill text-primary me-1" style={{ color: 'rgb(124, 181, 236)' }}></i><span>ETH Lowest Balance</span>
                    </h5>
                    <div className="text-muted small mb-1">On Thu 21, Feb 2019</div>
                    <div className="fw-bold text-muted">274,999.9994549656 ETH</div>
                </div>
                <div className="col-md-6 col-lg-3 py-3 bs-ether-right-vertical-line">
                    <h5 className="h6 fw-bold mb-1 bs-card-header-title">
                        <i className="bi bi-square-fill me-1" style={{ color: 'rgb(67, 67, 72)' }}></i><span>USD Highest Value</span>
                    </h5>
                    <div className="text-muted small mb-1">On Sun 26, Dec 2021</div>
                    <div className="fw-bold text-muted">USD 1,117,446,111.42</div>
                </div>
                <div className="col-md-6 col-lg-3 py-3">
                    <h5 className="h6 fw-bold mb-1 bs-card-header-title">
                        <i className="bi bi-square-fill me-1" style={{ color: 'rgb(67, 67, 72)' }}></i><span>USD Lowest Value</span>
                    </h5>
                    <div className="text-muted small mb-1">On Sun 24, Feb 2019</div>
                    <div className="fw-bold text-muted">USD 36,690,499.93</div>
                </div>
            </div> */}
            {/* <hr className='bs-ether-balance-hr'/> */}

            <div className="py-3 mb-2">
                <CoinBalance/>
            </div>
        </div>
    );
};

export default AnalyticsEtherBalance;
